(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rymar-find-installer-applications"] && !Shopify.designMode) return;
  try {
    
  // Keep native anchor navigation and the theme's reduced-motion-aware scrolling.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('.rymar-installer-applications__link[data-installer-project]');
    if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const field = document.querySelector('#find-an-installer select[name="contact[Project Type]"]');
    const category = link.dataset.installerProject;
    if (!field || !category || !Array.from(field.options).some((option) => option.value === category)) return;
    field.value = category;
    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  });

  if (!customElements.get('rymar-project-carousel')) {
    customElements.define('rymar-project-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.rymar-installer-applications__grid');
        if (!this.track) return;
        this.cards = Array.from(this.track.children);
        this.navigation = this.querySelector('.rymar-installer-applications__navigation');
        this.indicators = Array.from(this.navigation.querySelectorAll('button'));
        this.mobile = window.matchMedia('(max-width: 767px)');
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.update = () => {
          const left = this.track.getBoundingClientRect().left;
          this.active = this.cards.reduce((nearest, card, index) =>
            Math.abs(card.getBoundingClientRect().left - left) < Math.abs(this.cards[nearest].getBoundingClientRect().left - left) ? index : nearest, 0);
          this.indicators.forEach((button, index) => {
            if (index === this.active) button.setAttribute('aria-current', 'true');
            else button.removeAttribute('aria-current');
          });
        };
        this.scheduleUpdate = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(this.update);
        };
        this.setMode = () => {
          this.navigation.hidden = !this.mobile.matches;
          if (this.mobile.matches) this.track.setAttribute('tabindex', '0');
          else this.track.removeAttribute('tabindex');
          this.scheduleUpdate();
        };
        this.track.addEventListener('scroll', this.scheduleUpdate, { ...options, passive: true });
        this.track.addEventListener('keydown', (event) => {
          if (!this.mobile.matches || event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
          const indices = { ArrowRight: this.active + 1, ArrowLeft: this.active - 1, Home: 0, End: this.cards.length - 1 };
          if (!(event.key in indices)) return;
          event.preventDefault();
          this.goTo(indices[event.key]);
        }, options);
        this.track.addEventListener('focusin', (event) => {
          const card = event.target.closest('.rymar-installer-applications__item');
          if (card && this.mobile.matches) this.goTo(this.cards.indexOf(card));
        }, options);
        this.indicators.forEach((button, index) => button.addEventListener('click', () => this.goTo(index), options));
        this.mobile.addEventListener('change', this.setMode, options);
        this.resizeObserver = new ResizeObserver(this.scheduleUpdate);
        this.resizeObserver.observe(this.track);
        this.setMode();
      }

      goTo(index) {
        if (!this.mobile.matches) return;
        const card = this.cards[Math.max(0, Math.min(index, this.cards.length - 1))];
        this.track.scrollTo({
          left: this.track.scrollLeft + card.getBoundingClientRect().left - this.track.getBoundingClientRect().left,
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }

      disconnectedCallback() {
        this.events?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rymar-find-installer-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rymar-installer-faq')) {
    customElements.define('rymar-installer-faq', class extends HTMLElement {
      connectedCallback() {
        this.events = new AbortController();
        this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
        const options = { signal: this.events.signal };
        this.items = Array.from(this.querySelectorAll('details')).map((item) => {
          const state = { item, summary: item.querySelector('summary'), answer: item.querySelector('.rymar-installer-faq__answer'), expanded: item.open, animations: [] };
          state.summary.addEventListener('click', (event) => {
            if (event.defaultPrevented) return;
            event.preventDefault();
            this.toggleItem(state, !state.expanded);
          }, options);
          return state;
        });
        const settle = () => this.items.forEach((state) => { if (state.animations.length) this.finishItem(state); });
        this.motion.addEventListener('change', settle, options);
        window.addEventListener('resize', settle, options);
        this.addEventListener('shopify:block:select', (event) => {
          const state = this.items.find(({ item }) => item === event.target || item.contains(event.target));
          if (state) { state.expanded = true; this.finishItem(state); }
        }, options);
      }

      cancelAnimations(state) {
        state.animations.forEach((animation) => { animation.onfinish = null; animation.cancel(); });
        state.animations = [];
      }

      finishItem(state) {
        this.cancelAnimations(state);
        state.item.open = state.expanded;
        state.summary.setAttribute('aria-expanded', String(state.expanded));
        state.item.removeAttribute('data-closing');
        state.item.style.removeProperty('overflow');
      }

      toggleItem(state, expanded) {
        const startHeight = state.item.getBoundingClientRect().height;
        const startOpacity = state.item.open ? getComputedStyle(state.answer).opacity : '0';
        this.cancelAnimations(state);
        state.expanded = expanded;
        state.summary.setAttribute('aria-expanded', String(expanded));
        if (this.motion.matches || !state.item.animate) { this.finishItem(state); return; }
        state.item.open = true;
        state.item.toggleAttribute('data-closing', !expanded);
        const styles = getComputedStyle(state.item);
        const borderHeight = parseFloat(styles.borderTopWidth) + parseFloat(styles.borderBottomWidth);
        const endHeight = expanded ? state.item.getBoundingClientRect().height : state.summary.getBoundingClientRect().height + borderHeight;
        state.item.style.overflow = 'hidden';
        const timing = { duration: 250, easing: 'cubic-bezier(0.2, 0.6, 0.2, 1)', fill: 'both' };
        const height = state.item.animate({ height: [`${startHeight}px`, `${endHeight}px`] }, timing);
        const opacity = state.answer.animate({ opacity: [startOpacity, expanded ? '1' : '0'] }, timing);
        state.animations = [height, opacity];
        height.onfinish = () => this.finishItem(state);
      }

      disconnectedCallback() {
        this.events?.abort();
        this.items?.forEach((state) => this.finishItem(state));
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rymar-find-installer-form"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rymar-installer-request')) {
    customElements.define('rymar-installer-request', class extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        if (!this.form) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.storageKey = `rymar-installer-request:${this.form.id}`;
        const success = this.querySelector('[data-installer-success]');
        if (success) {
          try { sessionStorage.removeItem(this.storageKey); } catch (_) { /* Storage may be unavailable. */ }
          success.focus();
          return;
        }
        this.button = this.form.querySelector('button[type="submit"]');
        this.buttonLabel = this.button.querySelector('[data-submit-label]');
        this.originalLabel = this.buttonLabel.textContent;
        this.status = this.querySelector('[data-submit-status]');
        this.details = this.querySelector('details');
        this.method = this.form.elements.namedItem('contact[Preferred Contact Method]');
        this.phone = this.form.elements.namedItem('contact[phone]');
        this.permission = this.form.elements.namedItem('contact[Permission for project texts]');
        const fields = Array.from(this.form.elements).filter((field) => field.name.startsWith('contact[') && field.type !== 'hidden');
        const serverError = this.querySelector('.rymar-installer-form__status--error');
        // Short-lived, per-tab recovery for custom fields Shopify may not echo on errors.
        try {
          const saved = JSON.parse(sessionStorage.getItem(this.storageKey) || 'null');
          if (saved && Date.now() - saved.time < 30 * 60 * 1000 && serverError) {
            fields.forEach((field) => {
              if (!Object.prototype.hasOwnProperty.call(saved.values, field.name)) return;
              const value = saved.values[field.name];
              if (field.type === 'checkbox') field.checked = value === true;
              else {
                if (field.name === 'contact[Project Type]' && ['Playground', 'Rooftop / Balcony'].includes(value) && !Array.from(field.options).some((option) => option.value === value)) field.add(new Option(value, value));
                field.value = value;
              }
            });
            this.details.open = true;
          } else if (saved && Date.now() - saved.time >= 30 * 60 * 1000) sessionStorage.removeItem(this.storageKey);
        } catch (_) { /* Native form operation does not depend on storage. */ }
        this.validatePreference = () => {
          const needsPhone = ['Phone', 'Text Message'].includes(this.method.value);
          this.phone.setCustomValidity(needsPhone && !this.phone.value.trim() ? 'Enter a phone number for your preferred contact method, or choose Email.' : '');
          this.permission.setCustomValidity(this.method.value === 'Text Message' && !this.permission.checked ? 'Give permission for project-related texts, or choose another contact method.' : '');
        };
        this.validatePreference();
        const showError = (field) => {
          const message = this.querySelector(`[id="${field.id}-error"]`);
          if (message) {
            message.textContent = field.validationMessage;
            message.hidden = field.validity.valid;
          }
          if (field.validity.valid) field.removeAttribute('aria-invalid');
          else field.setAttribute('aria-invalid', 'true');
        };
        this.form.addEventListener('invalid', (event) => {
          const details = event.target.closest('details');
          if (details) details.open = true;
          showError(event.target);
        }, { ...options, capture: true });
        this.form.addEventListener('input', (event) => {
          this.validatePreference();
          if (event.target.matches('input, select, textarea') && event.target.hasAttribute('aria-invalid')) showError(event.target);
          [this.phone, this.permission].forEach((field) => { if (field.hasAttribute('aria-invalid')) showError(field); });
        }, options);
        this.form.addEventListener('change', this.validatePreference, options);
        this.form.addEventListener('submit', (event) => {
          if (this.submitting) { event.preventDefault(); return; }
          this.validatePreference();
          if (!this.form.reportValidity()) { event.preventDefault(); return; }
          try {
            const values = Object.fromEntries(fields.map((field) => [field.name, field.type === 'checkbox' ? field.checked : field.value]));
            sessionStorage.setItem(this.storageKey, JSON.stringify({ time: Date.now(), values }));
          } catch (_) { /* Continue with native submission if storage is blocked. */ }
          this.submitting = true;
          queueMicrotask(() => {
            // Shopify's spam challenge may cancel submission and resume it later.
            if (event.defaultPrevented) { this.resetSubmission(); return; }
            this.button.disabled = true;
            this.form.setAttribute('aria-busy', 'true');
            this.buttonLabel.textContent = 'Sending request…';
            this.status.textContent = 'Sending your installer request.';
          });
        }, options);
        window.addEventListener('pageshow', () => this.resetSubmission(), options);
        if (serverError) serverError.focus();
      }

      resetSubmission() {
        this.submitting = false;
        this.button.disabled = false;
        this.form.removeAttribute('aria-busy');
        this.buttonLabel.textContent = this.originalLabel;
        this.status.textContent = '';
      }

      disconnectedCallback() { this.events?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
